<!--Navbar-->
<mdb-navbar SideClass="navbar navbar-expand-lg navbar-dark red darken-4" [containerInside]="false">

    <!-- Navbar brand -->
    <mdb-navbar-brand><a class="navbar-brand" routerLink="/home" >Exchange4Students</a></mdb-navbar-brand>
  
    <!-- Collapsible content -->
    <links>
  
      <!-- Links -->
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
            <a class="nav-link waves-light" mdbWavesEffect routerLink="/book-page" routerLinkActive="active">Books</a>
        </li>
        <li class="nav-item">
            <a class="nav-link waves-light" mdbWavesEffect routerLink="/clothing-page" routerLinkActive="active">Clothing</a>
        </li>
        <li class="nav-item">
            <a class="nav-link waves-light" mdbWavesEffect routerLink="/furniture-page" routerLinkActive="active">Furniture</a>
        </li>
        <li class="nav-item">
            <a class="nav-link waves-light" mdbWavesEffect routerLink="/electronics-page" routerLinkActive="active">Electronics</a>
        </li>
        <li class="nav-item">
            <a class="nav-link waves-light" mdbWavesEffect routerLink="/sports-page" routerLinkActive="active">Sports Gear</a>
        </li>

        <!-- Search form -->
        <!--
        <form class="form-inline waves-light" mdbWavesEffect>
            <div class="md-form my-0">
                <input class="form-control mr-sm-2" type="text" size="30" placeholder="Search Catalog">
            </div>
        </form>
        -->
    </ul>
    <!-- Links -->
  
    <ul class="navbar-nav ml-auto nav-flex-icons">
        <li class="nav-item">
            <a class="nav-link" mdbWavesEffect routerLink="/listing-page" routerLinkActive="active"><mdb-icon fas icon="plus"></mdb-icon>Add Listing</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" mdbWavesEffect routerLink="/cart" routerLinkActive="active"><mdb-icon fas icon="shopping-cart"></mdb-icon>Cart</a>
        </li>
        <li class="nav-item dropdown" dropdown>
            <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
                <mdb-icon fas icon="user"></mdb-icon>{{auth.getUsername()}}<span class=""></span></a>
            <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown dropdown-primary" role="menu">
                <a class="dropdown-item waves-light" mdbWavesEffect routerLink="/view-listings" style="font-size: medium;">My Listings</a>
                <a class="dropdown-item waves-light" mdbWavesEffect routerLink="/view-orders" style="font-size: medium;">My Orders</a>
                <a class="dropdown-item waves-light" mdbWavesEffect (click)="auth.deleteAccount()" style="font-size: medium;">Delete Account</a>
                <div class="divider dropdown-divider"></div>
                <a class="dropdown-item waves-light" mdbWavesEffect (click)="auth.signOut()" style="font-size: medium;">Log out</a>
            </div>
        </li>
    </ul>
    
    </links>
    <!-- Collapsible content -->
  
  </mdb-navbar>
  <!--/.Navbar-->

  <router-outlet></router-outlet>
